import React from "react"

import "./Login.css"

import {WelcomeAccountPage} from "./components/WelcomeAccountPage"

export const ResetPasswordEmailSent: React.FC = (): React.ReactElement =>
  <WelcomeAccountPage>
    <>Reset password email has been sent, please check your email</>
  </WelcomeAccountPage>